import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import {
  InfiniteScrollCustomEvent,
  IonButton,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
} from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import type { IInfiniteScrollCollectionVm } from '@okcargo-apps/layout-ionic';
import {
  EmptyResultComponent,
  SkeletonCardTwoColumnsComponent,
  SpinnerLoadingComponent,
} from '@okcargo-apps/layout-ionic';
import type { IFreightAvailable } from '@okcargo-apps/shared-domain';
import { FreightAvailableCardComponent } from '../freight-available-card/freight-available-card.component';

@Component({
  selector: 'lib-freight-available-list-section',
  templateUrl: './freight-available-list-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonButton,
    FreightAvailableCardComponent,
    SkeletonCardTwoColumnsComponent,
    SpinnerLoadingComponent,
    EmptyResultComponent,
  ],
})
export class FreightAvailableListSectionComponent {
  public readonly vm = input.required<IInfiniteScrollCollectionVm<IFreightAvailable>>();

  public readonly loadNext = output<void>();
  public readonly retry = output<void>();

  protected onIonInfinite(event: InfiniteScrollCustomEvent): void {
    this.loadNext.emit();
    event.target.complete();
  }
}
